export default "__VITE_ASSET__K2$v1_kY__"